<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-card max-width="75%" width="500" flat>
        <v-row class="d-flex">
          <h1 class="mb-4">Confirma tu servicio</h1>
        </v-row>

        <v-row class="d-flex" v-if="formOkBoy.tipoServicio === 'Estacionario'">
          <h2 class="mb-4">Tu recarga</h2>
        </v-row>

        <v-row
          align="center"
          justify="center"
          v-if="formOkBoy.tipoServicio === 'Estacionario'"
        >
          <v-col>
            <v-row align="center" justify="center">
              <img src="../assets/estacionario.svg" width="60%" class="ma-3" />
            </v-row>
          </v-col>
          <v-col cols="5">
            <v-row align="center" justify="center">
              <p class="above-badge">Servicio de gas estacionario</p>
              <div>
                <img src="../assets/Badge.png" class="badge-container" />
                <div class="badge-text">
                  <p class="colorized">Litros completos</p>
                  <v-btn
                    color="primary"
                    text
                    x-small
                    @click="toKnowCompleteLiter()"
                    >Conocer más</v-btn
                  >
                  <!-- <p>Proveedor certificado</p> -->
                </div>
              </div>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="center">
              <h1>${{ formOkBoy.cantidadGasEstacionario }}</h1>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="d-flex" v-if="formOkBoy.tipoServicio === 'Cilindro'">
          <h2 class="mb-4">Tu cilindro</h2>
        </v-row>

        <v-row
          align="center"
          justify="center"
          v-if="formOkBoy.tipoServicio === 'Cilindro'"
        >
          <v-col>
            <v-row align="center" justify="center">
              <img src="../assets/cilindro.svg" width="35%" class="ma-3" />
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="center">
              <p>Servicio de gas de cilindro</p>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="center">
              <h1>${{ formOkBoy.cantidadGasCilindro }}</h1>
            </v-row>
          </v-col>
        </v-row>

        <v-row align="center" justify="center">
          <v-col>
            <v-row align="center" justify="center">
              <img src="../assets/ok.svg" width="50%" class="ma-3" />
            </v-row>
          </v-col>
          <v-col cols="5">
            <v-row align="center" justify="center">
              <p class="no-margin">Cuota de servicio</p>
              <!-- <v-btn color="primary" text x-small @click="toConoceMas()">Conocer más</v-btn> -->
            </v-row>
            <v-row align="center" justify="center">
              <p v-if="this.viewSaturationFee" class="no-margin">
                Tarifa dinámica * {{ this.formOkBoy.saturationRate }}X
              </p>
              <v-btn color="primary" text x-small @click="toConoceMas()"
                >Conocer más</v-btn
              >
            </v-row>
          </v-col>
          <v-col cols="4">
            <v-row align="center" justify="center">
              <h3>
                ${{
                  this.formOkBoy.serviceFee
                    ? this.formOkBoy.serviceFee
                    : this.formOkBoy.comision || 0
                }}
              </h3>
            </v-row>
            <v-row
              v-if="this.viewSaturationFee"
              align="center"
              justify="center"
            >
              <h3 class="mb-20">${{ this.formOkBoy.saturationFee || 0 }}</h3>
            </v-row>
          </v-col>
        </v-row>

        <v-row v-if="viewPromocode" align="center" justify="center">
          <v-col>
            <v-row align="center" justify="center" class="mt-6">
              <p>¿Tienes un cupón?</p>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="center">
              <v-text-field
                v-model="codigoDescuento"
                placeholder="OK100"
                @keyup="uppercaseCodigo()"
                maxlength="8"
              ></v-text-field>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="center">
              <v-btn
                color="secondary"
                class="mt-4"
                :disabled="!codigoDescuento"
                @click="getDescuento(codigoDescuento)"
                >Aplicar</v-btn
              >
            </v-row>
          </v-col>
        </v-row>

        <v-row v-if="viewPromocode" align="center" justify="center">
          <v-col>
            <v-row align="center" justify="center">
              <img src="../assets/cupon.svg" width="60%" class="ma-3" />
            </v-row>
          </v-col>
          <v-col cols="5">
            <v-row align="center" justify="center">
              <p>
                Cupón de descuento:
                <!-- <b v-if="formOkBoy.usuarioNuevo && codigoDescuento === null">
                  "1era vez"
                </b> -->
                <b v-if="codigoDescuento && codigoDescuentoFlag">
                  {{ formOkBoy.cuponServicio }}
                </b>
              </p>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="center">
              <h1 class="Descuento">-${{ formOkBoy.descuento }}</h1>
            </v-row>
          </v-col>
        </v-row>

        <v-row align="center" justify="center">
          <v-col>
            <v-row>
              <p>¿Deseas darle una propina a tu aliado?</p>
            </v-row>
            <v-row class="tip-array">
              <div v-for="tip in this.tips" v-bind:key="tip.amount">
                <div
                  class="tip"
                  :class="{ selected: selectedTip === tip.amount }"
                  @click="setTip(tip.amount)"
                >
                  {{ tip.description }}
                </div>
              </div>
              <currency-input
                v-if="this.selectedTip === 0"
                type="text"
                class="otherTip"
                :options="{ currency: 'MXN' }"
                placeholder="$0"
                v-model="otherTip"
              />
            </v-row>
          </v-col>
        </v-row>

        <v-divider inset></v-divider>

        <v-row class="d-flex justify-center">
          <v-row class="d-flex justify-end ma-4">
            <v-col>
              <v-row align="center" justify="center">
                <h2>Total a pagar:</h2>
              </v-row>
            </v-col>
            <v-col>
              <v-row align="center" justify="end">
                <h1>${{ total() }}</h1>
              </v-row>
            </v-col>
          </v-row>
        </v-row>

        <v-divider></v-divider>

        <v-row class="d-flex">
          <h2 class="mb-4">Tu servicio agendado</h2>
        </v-row>

        <v-row align="center" justify="center">
          <v-col>
            <v-row align="center" justify="center">
              <v-avatar size="60">
                <img src="../assets/usuario.svg" />
              </v-avatar>
            </v-row>
          </v-col>
          <v-col cols="5">
            <v-row align="center" justify="start">
              <h4>{{ formOkBoy.nombreCliente }}</h4>
            </v-row>
            <v-row align="center" justify="start">
              <p>{{ formOkBoy.numeroCelular }}</p>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="center">
              <v-btn outlined @click="changeAccount()">Cambiar</v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-row align="center" justify="center">
          <v-col>
            <v-row align="center" justify="center">
              <v-avatar size="60">
                <img src="../assets/agendado.svg" />
              </v-avatar>
            </v-row>
          </v-col>
          <v-col cols="5">
            <v-row align="center" justify="start">
              <h4>
                {{
                  formOkBoy.fechaServicio.toLocaleString() +
                  " - " +
                  formOkBoy.horaServicio
                }}
              </h4>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="center">
              <v-btn outlined @click="changeDate()">Cambiar</v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-row align="center" justify="center">
          <v-col>
            <v-row align="center" justify="center">
              <v-avatar size="60">
                <img src="../assets/card.svg" />
              </v-avatar>
            </v-row>
          </v-col>
          <v-col cols="5">
            <v-row align="center" justify="start">
              <h4>{{ tipoPago() }}</h4>
              <p v-if="formOkBoy.formaPago === 'Tarjeta'">
                Terminación: ****{{ terminacionTarjeta() }}
              </p>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="center">
              <v-btn outlined @click="changePay()">Cambiar</v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <MapConfirmServiceVue />

        <v-row>
          <v-col cols="8">
            <v-row align="center" justify="center">
              <p>
                {{
                  formOkBoy.address.street +
                  " " +
                  formOkBoy.address.numExt +
                  " " +
                  formOkBoy.address.suburb +
                  " " +
                  formOkBoy.address.municipality +
                  " " +
                  formOkBoy.address.state +
                  " " +
                  formOkBoy.address.zipcode +
                  ", " +
                  formOkBoy.address.numInt +
                  ", " +
                  formOkBoy.address.reference
                }}
              </p>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="center">
              <v-btn outlined @click="changeDirection()">Cambiar</v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-btn
            class="buttonPrimary"
            block
            @click="toTracing()"
            :disabled="this.loader"
            >Finalizar</v-btn
          >
        </v-row>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import Axios from "axios"
import { mapFields } from "vuex-map-fields"
import MapConfirmServiceVue from "./MapConfirmService.vue"
import CurrencyInput from "./CurrencyInput.vue"
var mixpanel = require("mixpanel-browser")
import config from "../config"
mixpanel.init(config.key)

export default {
  computed: {
    ...mapFields([
      "servicioSolicitado",
      "landingCounter",
      "pagoTarjetaMaximoFlag",
      "contadorDatos",
      "formOkBoy",
      "conoceMasModal",
      "completeLitersModal",
      "otherTipModal",
      "showMessage",
      "message",
      "loader",
    ]),
    viewPromocode: function () {
      if (this.formOkBoy.tipoServicio === "Estacionario") {
        return true
      }
      return false
    },
  },
  components: {
    MapConfirmServiceVue,
    CurrencyInput,
  },
  data() {
    return {
      viewSaturationFee: false,
      codigoDescuentoFlag: false,
      codigoDescuento: null,
      tips: [],
      selectedTip: 0,
      otherTip: 0,
    }
  },
  methods: {
    getServiceFees() {
      this.loader = true
      Axios.get(
        `${config.apiBaseUrl}/checkout/summary/web/${this.formOkBoy.numeroCelular}`,
        {
          params: {
            serviceDate: this.formOkBoy.dateServices
              .toString()
              .substr(0, 19)
              .split("T")
              .join(" "),
            serviceTypeUuid: "3066029c-4713-4e26-aef7-42458bb216ce",
            latitude: this.formOkBoy.address.latitude,
            longitude: this.formOkBoy.address.longitude,
            amount: this.formOkBoy.montoTotalGas * 100,
          },
          headers: {
            "x-api-key": config.apiKey,
          },
        }
      )
        .then((response) => {
          this.loader = false
          this.formOkBoy.saturationFee = response.data.saturationFee / 100
          this.formOkBoy.saturationRate =
            response.data.saturationMultiplier.toString()
          this.formOkBoy.iva = response.data.iva
          this.formOkBoy.serviceFee = response.data.serviceFee / 100

          this.viewSaturationFee =
            this.formOkBoy.saturationFee && +this.formOkBoy.saturationFee > 0
        })
        .catch((error) => {
          console.error(error)
          this.loader = false
        })
    },
    toTracing() {
      this.getDataServices()
    },
    changeAccount() {
      this.landingCounter = 1
      this.contadorDatos = 0
    },
    changeDate() {
      this.landingCounter = 2
    },
    changePay() {
      this.landingCounter = 3
    },
    changeDirection() {
      this.landingCounter = 1
      this.contadorDatos = 2
    },

    total() {
      let total = 0
      let services = this.formOkBoy.cantidadGasCilindro
      let descuento = 0
      if (this.formOkBoy.tipoServicio === "Estacionario") {
        descuento = this.formOkBoy.descuento
        services = this.formOkBoy.cantidadGasEstacionario
      } else {
        this.formOkBoy.descuento = 0
        this.formOkBoy.promocode = ""
        this.formOkBoy.cuponServicio = ""
      }

      total =
        +services +
        (+this.formOkBoy.serviceFee
          ? +this.formOkBoy.serviceFee
          : +this.formOkBoy.comision) +
        (+this.otherTip > 0 ? +this.otherTip : +this.selectedTip / 100) +
        (+this.formOkBoy.saturationFee || 0) -
        +descuento
      return total
    },
    uppercaseCodigo() {
      this.codigoDescuento = this.codigoDescuento.toUpperCase()
    },
    tipoPago() {
      // let tipoPago = ""
      switch (this.formOkBoy.formaPago) {
        case "Tarjeta":
          return "Pago con tarjeta"
        case "Terminal":
          return "Pago con terminal"
        case "Efectivo":
          return "Pago en efectivo"
      }
    },
    terminacionTarjeta() {
      let numTarjeta = this.formOkBoy.numeroTarjeta
      return numTarjeta.substr(12, 5)
    },
    toConoceMas() {
      this.conoceMasModal = true
    },
    toKnowCompleteLiter() {
      this.completeLitersModal = true
    },
    getDescuento(codigoDescuento) {
      this.loader = true
      Axios.get(
        config.apiBaseUrl +
          "/services/promocodes/" +
          codigoDescuento +
          "/discount",
        {
          params: {
            phoneNumber: this.formOkBoy.numeroCelular,
          },
          headers: {
            "x-api-key": config.apiKey,
          },
        }
      )
        .then((response) => {
          const serviceAmount =
            this.formOkBoy.tipoServicio === "Cilindro"
              ? this.formOkBoy.cantidadGasCilindro
              : this.formOkBoy.cantidadGasEstacionario

          if (
            response.data.serviceTypePromocode &&
            response.data.serviceTypePromocode.length > 0
          ) {
            const foundServiceType = response.data.serviceTypePromocode.find(
              (obj) =>
                obj.serviceTypeUuid === "3066029c-4713-4e26-aef7-42458bb216ce"
            )
            if (!foundServiceType) {
              this.message = `Código no válido`
              this.showMessage = true
              this.loader = false
              this.codigoDescuentoFlag = false
              this.formOkBoy.cuponServicio = ""
              this.formOkBoy.descuento = 0
              this.codigoDescuento = null
              return
            }

            if (
              foundServiceType.minPurchaseAmount &&
              foundServiceType.minPurchaseAmount > 0 &&
              serviceAmount < foundServiceType.minPurchaseAmount / 100
            ) {
              this.message = `El servicio no cuenta con el mínimo de compra ($${foundServiceType.minPurchaseAmount / 100})`
              this.showMessage = true
              this.loader = false
              this.codigoDescuentoFlag = false
              this.formOkBoy.cuponServicio = ""
              this.formOkBoy.descuento = 0
              this.codigoDescuento = null
              return
            }

            this.loader = false
            this.codigoDescuentoFlag = true
            this.formOkBoy.cuponServicio = codigoDescuento
            this.formOkBoy.descuento = foundServiceType.maxDiscountAmount / 100
            this.showMessage = true
            this.message =
              "Descuento de: $" + foundServiceType.maxDiscountAmount / 100
            return
          } else if (
            response.data.minPurchase &&
            response.data.minPurchase > 0 &&
            serviceAmount < response.data.minPurchase
          ) {
            this.message = `El servicio no cuenta con el mínimo de compra ($${response.data.minPurchase})`
            this.showMessage = true
            this.loader = false
            this.codigoDescuentoFlag = false
            this.formOkBoy.cuponServicio = ""
            this.formOkBoy.descuento = 0
            this.codigoDescuento = null
            return
          }

          this.loader = false
          this.codigoDescuentoFlag = true
          this.formOkBoy.cuponServicio = codigoDescuento
          this.formOkBoy.descuento = response.data.discount
          this.showMessage = true
          this.message = "Descuento de: $" + response.data.discount
        })
        .catch((error) => {
          this.loader = false
          this.codigoDescuentoFlag = false
          this.formOkBoy.cuponServicio = ""
          this.formOkBoy.descuento = 0
          this.codigoDescuento = null

          if (codigoDescuento !== null) {
            console.error(error)
            this.showMessage = true
            this.message = "Código no valido."
          }
        })
    },
    getDataServices() {
      let DataServices = {
        amount: `${Math.round(this.formOkBoy.montoTotalGas * 100)}`,
        productShowcaseUuid: this.formOkBoy.productShowcaseUuid,
        fee:
          ((this.formOkBoy.serviceFee || 0) +
            (this.formOkBoy.saturationFee || 0)) *
          100,
        serviceFee: (this.formOkBoy.serviceFee || 0) * 100,
        saturationMultiplier: this.formOkBoy.saturationRate,
        iva: this.formOkBoy.iva,
        tip: +this.otherTip > 0 ? +this.otherTip * 100 : +this.selectedTip || 0,
        saturationFee: (this.formOkBoy.saturationFee || 0) * 100,
        discount: `${(this.formOkBoy.descuento || 0) * 100}`,
        serviceDate: this.formOkBoy.dateServices.toString(),
        paymentTypeId: this.formOkBoy.formaPagoID.toString(),
        promocode: this.formOkBoy.cuponServicio,
        customerData: {
          phoneNumber: this.formOkBoy.numeroCelular.toString(),
          name: this.formOkBoy.nombreCliente.toString(),
          deviceType: "web",
          address: this.formOkBoy.address,
        },
        invoiceAddress: {
          street: this.formOkBoy.calleFacturacion,
          numExt: this.formOkBoy.numExteriorFacturacion,
          postalCode: this.formOkBoy.codigoPostalFacturacion,
          state: this.formOkBoy.estadoFacturacion,
          city: this.formOkBoy.ciudadFacturacion,
        },
      }

      if (this.formOkBoy.tipoServicio === "Cilindro") {
        DataServices.serviceType = "c352aee9-4217-4dea-acde-7446fe7bc501"
      } else {
        DataServices.serviceType = "3066029c-4713-4e26-aef7-42458bb216ce"
        if (DataServices.amount <= 500) {
          this.showMessage = true
          this.message = "La cantidad mínima de compra es $500.00"
        }
      }

      if (this.formOkBoy.formaPago === "Tarjeta") {
        DataServices.card = this.formOkBoy.cardCrypto
      }
      this.loader = true
      Axios.post(config.apiBaseUrl + "/services", DataServices, {
        headers: {
          "x-api-key": config.apiKey,
        },
      })
        .then((response) => {
          this.loader = false
          this.servicioSolicitado = true
          this.$router.push({ name: "PedidoExitoso" })
          mixpanel.track("Registro servicio.")
        })
        .catch((error) => {
          if (error.response.data.remainingAttempts === 0) {
            this.showMessage = true
            this.message =
              "Por políticas de la empresa ya no tienes permitido pagos con tarjeta"
            this.landingCounter = 3
            this.formOkBoy.formaPago = "Terminal"
            this.pagoTarjetaMaximoFlag = true
          }
          if (error.response.data.message === "Payment refused") {
            this.showMessage = true
            this.message = "Pago rechazado, intenta otro método de pago"
            this.landingCounter = 3
          } else {
            console.error(error)
          }
          this.loader = false
        })
    },
    getTips() {
      this.loader = true
      Axios.get(config.apiBaseUrl + "/checkout/tips", {
        headers: {
          "x-api-key": config.apiKey,
        },
      })
        .then((response) => {
          this.loader = false
          this.tips = response.data.tips
          this.tips.push({
            description: "Otro",
            amount: 0,
            recommended: false,
          })
          this.selectedTip = +this.tips.find((tip) => tip.recommended).amount
        })
        .catch((error) => {
          this.loader = false
          console.error(error)
        })
    },
    setTip(tip) {
      this.otherTip = 0
      this.selectedTip = +tip
    },
    getComision() {
      Axios.get(config.apiBaseUrl + "/commission", {
        headers: {
          "x-api-key": config.apiKey,
        },
      })
        .then((response) => {
          this.formOkBoy.comision = response.data.commission
        })
        .catch((error) => {
          console.error(error)
        })
    },
  },
  mounted() {
    this.getTips()
    this.getComision()
    this.getServiceFees()
  },
}

window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
  event: "Pageview",
  pagePath: "https://okboy.app/summary",
  pageTitle: "Service Summary for Confirmation",
});
</script>

<style scoped>
.Servicio {
  /* width: 180px;
  height: 50px; */
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  padding: 5%;
  color: #303034;
}
.Costo {
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.83;
  letter-spacing: -0.02px;
  color: #303034;
}
.Descuento {
  color: #28d7d8;
}
.theme--light.v-sheet {
  background-color: #f1f3f6;
  border-color: #f1f3f6;
  color: rgba(0, 0, 0, 0.87);
}

.badge-container {
  float: left;
  width: 40px;
  height: 40px;
}

.badge-text {
  margin-left: 45px;
}

.badge-text > p {
  margin-bottom: auto;
  font-size: 14px;
}

p.above-badge {
  margin-bottom: auto;
}

.no-margin {
  margin-bottom: auto;
}

.badge-text > p.colorized {
  font-weight: bold;
  color: #5932fd;
}

.mb-20 {
  margin-bottom: 20px;
}

.tip-array {
  margin: 0 auto;
}

.tip {
  cursor: pointer;
  width: 50px;
  height: 50px;
  background-color: white;
  border-radius: 25%;
  text-align: center;
  vertical-align: middle;
  line-height: 50px;
  margin: 0 5px;
}

.tip.selected {
  background-color: cyan;
}

.otherTip {
  /* remove default behavior */
  appearance: none;
  -webkit-appearance: none;

  /* usual styles */
  padding: 10px 15px;
  border: none;
  background-color: white;
  color: black;
  font-weight: 600;
  border-radius: 5px;
  margin-left: 5px;
  width: 100px;
}
</style>